const pt = {
  Deposit: "Depósito",
  startedAt: "Iniciado em",
  noRollover: "Sem Rollover",
  completeness: "Cumprimento",
  clickHere: "Clique aqui",
  doYouHavePromoCode: "Você tem um código promocional?",
  finishedIn: "Finalizado em",
  provider: "Provedor",
  consolidatedValue: "Valor Consolidado",
  entryId: "ID do Lançamento",
  registrationDate: "Data de Cadastro",
  depositID: "ID Depósito",
  betStatus: {
    Pending: "Pendente",
    Lost: "Perdida",
    Awarded: "Premiada",
    Cashout: "Encerrada"
  },
  idBet: "ID Aposta",
  sport: "Esporte",
  cancellation: "Cancelamento",
  betDate: "Data da Aposta",
  infoPrizeValue: "Valor em premiações",
  resultDate: "Data do Resultado",
  numberOfGames: "N° de Jogos",
  multiplier: "Multiplicador",
  consultedOn: "Consultado em",
  download: "Download",
  noDataFount: "Nenhum dado encontrado!",
  loadingData: "Carregando dados...",
  deposits: "Depósitos",
  amountOfDeposits: "Qtd. Depósitos",
  onlineBalance: "Saldo Online",
  cellPhone: "Celular",
  usersPlurals: "Usuário | Usuários",
  depositsPlurals: "Depósito | Depósitos",
  noQuery: "Nenhuma consulta realizada",
  lastLogin: "Último login",
  birthday: "Nascimento",
  reports: "Relatórios",
  users: "Usuários",
  sortBy: "Ordenar por",
  affiliateCampaign: {
    title: "Campanhas",
    newCampaign: "Nova campanha",
    name: "Nome da campanha",
    numberOfClicks: "Qtd. de cliques",
    betQty: "Qtd. de apostas",
    usersQty: "Qtd. de usuários",
    firstDepositQty: "Qtd. de primeiro depósito",
    channel: "Rede",
    activate: "Ativar",
    deactivate: "Desativar",
    others: "Outros",
    socialMedia: "Rede social",
    campaignCode: "Código da campanha",
    createCampaign: "Criar campanha",
    activeCampaigns: "Campanhas ativas",
    othersInputText: "Informe outra rede social",
    copyLink: "Copiar link",
    goToCampaigns: "Ir para campanhas",
    campaignCreatedSuccessfully: "Campanha criada com sucesso!",
  },
  noTitle: "Sem título",
  gamesSingularPlural: "Jogos | {count} Jogo | {count} Jogos",
  includedGames: "Jogos inclusos na campanha",
  roundsQuantityTip:
    "Quantidade de rodadas disponíveis para todos os jogos incluídos nesta campanha.",
  roundsQuantity: "Total de Rodadas",
  loginExemptPlayer: "Login como jogador isento",
  titleDialogBlockUser: "Aviso: {idReason} bloqueado",
  messageDialogBlockUser: {
    securityReason:
      "Por motivos de segurança, a função de {idReason} foi temporariamente bloqueada.",
    getExplainingWithSupport:
      "Entre em contato com nosso suporte para solucionar dúvidas e prosseguir com as ações necessárias.",
    contactSupport: "Contate o suporte",
    reason: "Motivo: ",
    messagesTranslate: {
      thirdPartyData:
        "Para garantir a segurança financeira, suspendemos saques envolvendo dados de terceiros.",
      violationTermsAndConditions:
        "Para manter um ambiente justo, suspendemos contas e bloqueamos saques que não seguem nossas regras e termos de uso.",
      maliciousBets:
        "Suspendemos saques relacionados a apostas maliciosas para manter um ambiente de apostas justo e transparente.",
      multiAccounts:
        "Suspensões das ações de sacar ocorrem quando múltiplas contas são usadas pelo mesmo usuário/grupo para ganhos indevido.",
      suspiciousBehavior:
        "Para a segurança financeira de todos, suspendemos saques relacionados a comportamento suspeito ou atividades fraudulentas.",
      affiliateAccount:
        "Esta é uma conta parceira, para sacar seus ganhos entre em contato com a administração.",
      exemptBetCasino: "Isenção de apostas do cassino",
      suspiciousActivityDetected: "Detecção de atividade suspeita.",
      abuseOfSystemCrashes: "Abuso de falhas do sistema.",
      gamblerShowingCompulsiveBehavior:
        "Jogador apresentando comportamento compulsivo.",
      playerAttemptingToUseMethodsThatViolate:
        "Jogador realizando tentativas de utilizar métodos que ferem nossas políticas e termos de uso.",
      moduleUnavailableToThePlayer: "Módulo indisponível para o jogador.",
    },
  },
  noSportsPromoFound: "Não há promoções disponíveis para esportes no momento",
  searchByTitleAndGame: "Pesquisar por titulo ou nome do jogo",
  ativa: "Ativa",
  daysRemaining:
    "dias restantes | {count} dia restante | {count} dias restantes",
  forYouOpeningTxt: {
    intro:
      "Separamos promoções especialmente para você, todas reunidas em um só lugar!",
    howToWinFreeSpins: "Como ganhar as rodadas grátis?",
    development: `Para participar, basta clicar em Reivindicar nas promoções que mais te agradam! <br><br> Após isso, as rodadas serão automaticamente creditadas à sua conta para uso exclusivo nos jogos selecionados da promoção escolhida, e terão um período a serem usufruídas até expirarem. `,
    conclusion: "Aproveite e divirta-se!",
  },
  gotIt: "Entendi!",
  forYou: "Para você",
  ativas: "Ativas",
  sumFirstDeposits: "Soma de primeiros depósitos",
  winAmount: "Valor do prêmio",
  loadMore: "Carregar Mais",
  myPromotionsOpeningTxt:
    "Separamos promoções especialmente para você, todas reunidas em um só lugar! <br /><br /> <b>Como ganhar as rodadas grátis?</b> <br /> Para participar, basta clicar em Reivindicar nas promoções que mais te agradam! <br /><br /> Após isso, as rodadas serão automaticamente creditadas à sua conta para uso exclusivo nos jogos selecionados da promoção escolhida, e terão um período a serem usufruídas até expirarem. <br /><br /> Aproveite e divirta-se!",
  gameNotAvailable: "Jogo não disponível no momento.",
  pleaseTryAgainLater: "Por favor, tente novamente mais tarde.",
  recommended: "Recomendadas",
  recommendedForYou: "Recomendados para você",
  claim: "Reivindicar",
  theaterMode: "Modo Teatro",
  qtdDeposits: "Quantidade de Depósitos",
  registerDate: "Data de Registro",
  noDataForthisQuery: "Não há dados para esta consulta.",
  notFound: "Não encontrado.",
  cpaValue: "Valor de CPA",
  firstDeposit: "Primeiro Depósito",
  typeOfCPA: "Tipo de CPA",
  playerId: "ID Jogador",
  percent: "Percentual",
  fixedCommission: "Comissão Fixa",
  valueCpa: "Valor CPA",
  redeemTokenTitle: "Resgatar token",
  allowDeactivateCurrentPromo:
    "Estou ciente que ao resgatar meu token, a promoção vigente será desativada. E todo progresso anterior será perdido, incluindo apostas que ainda estejam pendentes de resolução.",
  infoRedeemToken: "Após resgatados, suas promoções aparecerão no menu de ",
  redeem: "Resgatar",
  insertToken: "Insira seu token",
  menuRedeemToken: "Resgate <br /> seu token",
  redeemToken: "Resgate aqui seu token",
  minPlayersCommissionTip:
    "Para ter comissionamento, precisa-se atingir o mínimo de usuários ativos.",
  minimum: "Mínimo",
  activeUsers: "Usuários ativos",
  remainingActivePlayers:
    "Você alcançou a quantidade mínima de usuários ativos. | Falta {remainingUsers} usuário ativo. | Faltam {remainingUsers} usuários ativos.",
  frequentlyAskedQuestions: "Dúvidas frequentes",
  depositClinPaysConfirmed: "Depósito confirmado.",
  // clinPays: {
  cardValidDate: "Digite o mês corretamente",
  nameAsShownOnCard: "Nome como mostrado no cartão",
  userAnotherCard: "Utilizar outro cartão",
  clinPaysFooter:
    "ClinPays - Garante transações mais seguras e detecção precoce de transações fraudulentas. Tem mais de quatro anos de experiência na área, comprometidos em fornecer a você tecnologias de meios de pagamento e produtos inovadores com a mais alta segurança estabelecida por marcas internacionais. ClinPays é certificado pelo padrão PCI DSS (Payment Card Industry Data Security Standard) fundado por várias instituições, incluindo Visa e Mastercard. Além disso, sua empresa pode ser gratuita ao autenticar cada transação com o 3DS 2.0.",
  saveCardText: "Salvar os dados do cartão para os próximos depósitos",
  securityCode: "Código de segurança",
  cvvTooltipText:
    "Digite o código (CVV) de 3 dígitos que está no verso do cartão",
  cardValidity: "Validade",
  cardNumber: "Número do cartão",
  nameOfCardHolder: "Nome do titular do cartão",
  // },
  seeAllGamesCategory: "+ Ver todos",
  feeValue: "Valor da Taxa",
  searchByGame: "Pesquisar por Jogo",
  noLoadPaymentMethods:
    "Não foi possível carregar os métodos de pagamento. Tente novamente mais tarde.",
  noLoadLicenses:
    "Não foi possível carregar as licenças. Tente novamente mais tarde.",
  noLoadPartner:
    "Não foi possível carregar os Parceiros. Tente novamente mais tarde.",
  paymentMethods: "MÉTODOS DE PAGAMENTO",
  maximumDepositAmount: "O valor máximo para depósito é de R$ {value}.",
  minimumDepositAmount: "O valor mínimo para depósito é de R$ {value}.",
  newDeposit: "Novo depósito",
  congratsDeposit:
    "Obrigado! Agora você pode aproveitar o melhor do entretenimento esportivo. Faça suas apostas e boa Sorte!",
  depositConfirmed: "Depósito PIX confirmado.",
  pixCopyPaste: "Código Pix Copia/Cola",
  depositPaymentProviderRules: {
    PixPay4Fun:
      "O PIX via Pay4Fun não aceita chaves aleatórias,<br />somente chaves tipo <strong>CPF</strong>, <strong>email</strong> ou <strong>celular</strong>.<br />Verifique o seu cadastro.",
    PixPaybrokersBrasilCash:
      "Os depósitos são realizados via Pix.<br />É obrigatório ter seu <strong>CPF</strong> cadastrado.",
    PixPaguePay:
      "Os depósitos são realizados via Pix.<br />É obrigatório ter seu <strong>CPF</strong> cadastrado.",
    PixPagFast:
      "Os depósitos são realizados via Pix.<br />É obrigatório ter seu <strong>CPF</strong> cadastrado.",
  },
  resendEmailTip:
    "Dica: Quando solicitar reenvio de email, sempre verifique o último email enviado!",
  dateExpiration: "Data de expiração",
  walletPay4FunFooter1:
    "A Pay4Fun é uma carteira 100% virtual, segura e rápida, para facilitar suas transações na Internet! E o melhor de tudo: sem custo algum* para seus depósitos através de Pix, transferência bancária, boleto ou cartão de crédito. Se você já possui uma conta Pay4Fun, selecione o valor desejado e clique em 'Depositar'. Você será redirecionado para o site da Pay4Fun para completar a transação e será encaminhado de volta ao",
  walletPay4FunFooter2:
    ", automaticamente, ao concluir sua transação na Pay4Fun. Para abrir sua conta Pay4Fun ou obter mais informações visite: www.p4f.com ou baixe o App.",
  walletPay4FunFooter2_1: "*em alguns casos, aplicam-se tarifas bancárias.",
  depositWalletPay4Fun: "Depósito via Carteira Pay4Fun",
  walletWithdrawalPay4Fun: "Saque para Carteira Pay4Fun",
  minValueDialog: "Min. R$",
  maxValueDialog: "Máx. R$",
  infoValue: "Informe o valor",
  bonusConversionConfirmation: "Confirmação de Conversão de Bônus",
  areYouSureYouWantToConvert: "Você tem certeza de que deseja converter",
  ofBonusIn: "de bônus em",
  ofRealBalance: "de saldo real",
  toRealBalance: "para saldo real",
  walletWithdrawalFooter1:
    "A Pay4Fun é uma carteira 100% virtual, segura e rápida, para facilitar suas transações na Internet! E o melhor de tudo: sem custo algum* para seus depósitos através de Pix, transferência bancária, boleto ou cartão de crédito. Se você já possui uma conta Pay4Fun, selecione o valor desejado, complete com os dados da sua conta Pay4Fun e clique em 'Sacar'. Você deverá aguardar o procedimento e confirmação do saque por parte do departamento financeiro do",
  walletWithdrawalFooter2:
    "Após confirmação, o valor sacado será transferido para sua conta Pay4Fun. Para abrir sua conta Pay4Fun ou obter mais informações visite: www.p4f.com ou baixe o App.",
  walletWithdrawalFooter2_1: "*Em alguns casos, aplicam-se tarifas bancárias.",
  paybrokersFooter1:
    "A Paybrokers presta serviços de Facilitação de Pagamentos (eFx), por meio de sua plataforma eletrônica moderna e segura para depósitos e retiradas de valores, facilitando compras online em sites internacionais.",
  paybrokersFooter2:
    "A Paybrokers segue o regramento do Banco Central do Brasil, assim como as melhores práticas internacionais em pagamentos.",
  settings: "Configurações",
  invalidPixKey: "Chave PIX inválida! Apenas CPF, email ou telefone.",
  needToRegisterPixKey: "Você precisa cadastrar a sua chave PIX",
  noPaymentMethodsMsg:
    "Nenhum método de pagamento disponível no momento. Tente novamente mais tarde!",
  depositPixByPayBrokers: "Depósito PIX via Paybrokers",
  brazilCashDeposit: "Depósito via Brasil Cash",
  brazilCashWithdraw: "Saque via Brasil Cash",
  withdrawalByPayBrokers: "Saque via Paybrokers",
  depositPixByPay4FunGo: "Depósito via Pay4Fun GO",
  withdrawalByPay4FunGo: "Saque via Pay4Fun GO",
  paagDeposit: "Depósito via Paag",
  paguePayDeposit: "Depósito via Pague Pay",
  pagFastDeposit: "Depósito via PagFast",
  paagWithdraw: "Saque via Paag",
  paguePayWithdraw: "Saque via Pague Pay",
  pagFastWithdraw: "Saque via PagFast",
  paagFooter: `A Paag é uma empresa especializada em soluções de pagamento para o setor
  de iGaming e apostas esportivas. Com foco em compliance e taxas
  competitivas, a Paag oferece soluções eficientes para a realização de
  transações financeiras de forma segura.`,
  paguePayFooter:
    "A PaguePay oferece soluções em gestão de pagamentos eletrônicos (eFX) para facilitar entradas e saídas de fundos, tornando mais simples a realização de compras em plataformas globais. Unimos nossa tecnologia à sua, possibilitando múltiplas opções financeiras aos seus usuários diretamente em seu aplicativo.",
  pagFastFooter: "A Pagfast oferece soluções em gestão de pagamentos eletrônicos (eFX) para facilitar entradas e saídas de fundos, tornando mais simples a realização de compras em plataformas globais. Unimos nossa tecnologia à sua, possibilitando múltiplas opções financeiras aos seus usuários diretamente em seu aplicativo.",
  pay4funWithdrawlFooterText1:
    "O Pay4Fun GO é um pagamento direto, seguro e rápido, facilitando suas transações na Internet! E o melhor de tudo: sem custo algum* para seus saques através de Pix ou transferência bancária. Basta selecionar o valor desejado e clicar em 'Sacar'. Você será redirecionado para completar a transação. Você deverá aguardar o procedimento e confirmação do saque por parte do departamento financeiro do ",
  pay4funWithdrawlFooterText2:
    "Após confirmação, o valor sacado será depositado na sua conta bancária. *Em alguns casos, aplicam-se tarifas bancárias.",
  pay4funDepositFooterText1:
    "O Pay4Fun GO é um pagamento direto, seguro e rápido, facilitando suas transações na Internet! E o melhor de tudo: sem custo algum* para seus depósitos através de Pix, transferência bancária. Basta selecionar o valor desejado e clicar em 'Depositar'. Você será redirecionado para completar a transação. Tão logo você conclua o pagamento na forma escolhida, o mesmo será automaticamente liberado no ",
  pay4funDepositFooterText2:
    "*Em alguns casos, aplicam-se tarifas bancárias. **Tempo de liberação varia em função da forma de pagamento escolhida.",
  cashoutAvailable: "Cashout Disponível",
  eventNumber: "Número de Eventos",
  useBonus: "Usar Bônus",
  bankVerificationIntroductionText:
    "A verificação bancária checa se a chave pix cadastrada confere com um dos Bancos autorizados pelo nosso sistema.",
  pixEditBlocked:
    "A edição de dados bancários está bloqueada, entre em contato com o suporte para alterar seus dados.",
  bankVerificationHowDoesItWorkText: "Como funciona?",
  bankVerificationText:
    "Realizaremos um saque de R$ 1,00 (Um Real) para validar se sua chave pix pertence a um dos Bancos autorizados. Se for bem sucedido, o usuário poderá realizar saques normalmente. Caso seja negado, o usuário ficará impedido de realizar saques, até que altere seus Dados Financeiros e indique uma chave pix que pertença a um dos Bancos autorizados pelo nosso sistema.",
  notRegistered: "Não cadastrado",
  profileBankVerificationDenied:
    "A verificação bancária foi negada. Verifique se há erros na chave pix informada e/ou se o banco cadastrado está entre os aceitos pelo nosso sistema.",
  successVerification: "Verificação bem-sucedida!",
  bankVerified: "Banco verificado",
  pendingVerification: "Verificação bancária pendente.",
  processingVerification: "Processando verificação.",
  verificationDenied: "Verificação negada, tente novamente.",
  maybeYouNeedChangeYourData:
    "Talvez você precise alterar os seus dados bancários",
  bankVerificationTitle: "Verificação Bancária",
  bankVerificationLearnMore:
    "A verificação bancária checa se a chave pix cadastrada confere com um dos bancos disponíveis. O Usuário não pode realizar saques até que a verificação seja concluída. Se for bem sucedida, o usuário poderá realizar saques normalmente. Caso seja negada, o usuário ficará impedido de realizar saques, até que altere seus dados financeiros e indique um novo banco que esteja na lista de bancos disponíveis em nosso sistema.",
  verifyBank: "Verificar",
  goToProfile: "ir para Perfil",
  learnMore: "Saiba mais",
  bankVerificationPending:
    "Faça a verificação bancária para poder realizar saques!",
  bankVerificationProcessing:
    "Processando verificação bancária. Aguarde alguns instantes.",
  bankVerificationDenied:
    "Verificação negada! Vá até 'Perfil' e altere os Dados Financeiros",
  searchYourBank: "Pesquise o banco da sua chave pix",
  showBalance: "Mostrar saldo",
  hideBalance: "Esconder saldo",
  refreshBalance: "Atualizar saldo",
  confirmByEmail: "Confirmar por email",
  affiliateCode: "Código de Afiliação (Opcional)",
  msgFavoritesLimit: "Você atingiu o máximo de favoritos",
  finished: "Encerrada",
  finishedPlural: "Encerradas",
  favorites: "Favoritos",
  noDataFound: "Não encontramos dados",
  minus: "subtraindo os",
  report: "Relatório",
  accountDisabled: "Conta desativada",
  disabled: "Desativado",
  totalAffiliates: "Total de afiliados",
  disabledByLoginAttempts: "Bloqueado por tentativas de login excedidas",
  accountConfirmation: "Confirmação de conta",
  blocked: "Bloqueado",
  suspended: "Suspenso",
  lastAccess: "Último Acesso",
  depositBalance: "Saldo Depósito",
  bonusBalance: "Saldo Bônus",
  dateRegistration: "Data de Cadastro",
  noRegister: "Não há registro",
  affiliatedPlayers: "Jogadores afiliados",
  rowsPerPage: "Linhas por página:",
  affiliates: "Afiliados",
  noSearchPerformed: "Nenhuma consulta realizada.",
  changeOddsConfigurationTooltip: "Mudanças de cotações",
  doNotAcceptOddsChanges: "Não aceitar mudanças nas cotas",
  acceptAboveOddsChanges: "Aceitar cotas mais altas",
  acceptAnyOddsChanges: "Aceitar qualquer cota",
  beCarefulLoginAttemptsTitle: "Tenha cuidado",
  beCarefulLoginAttemptsContentAfterRequisition1:
    "Você está errando a sua senha muitas vezes. Se continuar a errar a senha, sua conta será bloqueada.",
  beCarefulLoginAttemptsContentAfterRequisition2:
    "Você pode recuperar sua senha usando o botão abaixo, ou entrar em contato com o suporte.",
  beCarefulLoginAttemptsContentBeforeRequisition1:
    "Você está tentando fazer login com a mesma senha que acabou de tentar. Se continuar a errar a senha, sua conta será bloqueada.",
  beCarefulLoginAttemptsContentBeforeRequisition2:
    "Você pode recuperar sua senha usando o botão abaixo ou entrar em contato com o suporte.",
  updatedAt: "Atualizado em",
  read: "Lido",
  notRead: "Não lido",
  name: "Nome",
  loginCreditBuyer: "Insira o login do usuário para vender crédito",
  valueCredit: "Valor",
  confirmYourPassword: "Confirme sua senha",
  confirmYourPasswordDescription:
    "É preciso confirmar a sua senha pra fazer essa ação",
  noTime: "Sem tempo",
  addiction: "Viciado ou em risco de se viciar",
  dontWantToSay: "Não quero falar",
  instatisfactionOperator: "Insatisfação com o operador",
  instatisfactionBonus: "Insatisfação com as políticas de bônus",
  other: "Outro",
  suspensionReason: "Motivo da Suspensão",
  selectAReasonToSuspend: "Selecione um motivo para a suspensação",
  suspensionReasonDescription: "Insira um breve motivo para a suspensão",
  autoexclusionReason: "Motivo da Autoexclusão",
  autoexclusionReasonDescription: "Insira um breve motivo para a autoexclusão",
  unlimited: "Ilimitado",
  confirmation: "Confirmação",
  suspendAccount: "Suspender minha conta até esta data",
  autoexcludeAccount: "Autoexcluir minha conta até esta data",
  suspendQuestion: "Deseja suspender sua conta?",
  autoExcludeQuestion: "Deseja autoexcluir sua conta?",
  areaForPlayersLogged: "É necessário estar logado para suspender a conta",
  welcomeMsg: "Bem vindo a sua aplicação Vue.js",
  selection: "Seleção",
  ticket: "Bilhete",
  no_selection: "Nenhuma seleção",
  textPhonePreBet:
    "Preencha seu telefone para receber o código de Pré-Aposta por  SMS.",
  phone: "Telefone",
  phoneOrName: "Telefone ou nome",
  betBonus: "Apostar Bônus",
  value: "Valor",
  betWithBonus: "Apostar com Bônus?",
  possibleGain: "Possível Ganho",
  totalOdds: "Total odds",
  acceptChanges: "Aceitar alterações",
  deposit: "Depositar",
  bet: "Apostar",
  preBet: "Pré Apostar",
  depositToBet: "Deposite para apostar",
  betGreaterthanBonus: `O valor da sua aposta é maior que o seu bônus disponível`,
  pleaseLoginAgaing: "Realize o login novamente!",
  serverErrorTryAgain: "Erro no servidor, tente novamente!",
  playerHasregisterMsg:
    "Identificamos que você já tem um cadastro conosco, para continuar o login.",
  userFound: "Usuário encontrado",
  phoneIsMandatory: "O preenchimento do telefone é obrigatório!",
  rulesEventsMaxAlert: {
    term1: "Olá, Você tem o limite de",
    term2:
      " eventos por aposta, por favor retire algums eventos do carrinho para continuar.",
    term3: "(Existe",
    term4: "eventos no carrinho no momento.)",
  },
  checkPossibleGainAlert: `Você atingiu o possível ganho máximo`,
  checkBetAmountAlert: "Olá, a aposta mínima é de ",
  maximumMutiplierMsg: "Você atingiu o multiplicador máximo",
  noEventsFound: "Nenhum evento encontrado!",
  loading: "Carregando...",
  today: "Hoje",
  tomorrow: "Amanhã",
  currentPassword: "Senha atual",
  infoNewPassword: "Informe uma nova senha",
  consultBet: "Consultar Aposta",
  allSports: "TODOS OS ESPORTES",
  specialLists: "LISTAS ESPECIAIS",
  live: "Ao vivo",
  home: "Início",
  searchEvent: "Procurar Evento",
  sports: "Esportes",
  knowUs: "Conheça o site",
  register: "Cadastrar",
  login: "Entrar",
  loginInput: "Login",
  playResponsibly: "Jogue com responsabilidade.",
  prohibitedForUnder18: "Proibido para menores de 18 anos.",
  partnersAndSponsorships: "Parceiros e Patrocínios",
  allRightsReserved: "Todos os direitos reservados.",
  about: "Sobre",
  nameAndLastName: "Nome e Sobrenome",
  dateOfBirth: "Data de nascimento",
  optionalEmail: "Email (Opcional)",
  password: "Senha",
  loginOrEmail: "Login/E-mail",
  confirmPassword: "Confirme sua senha",
  consultYourAccountTextSMS: "Verifique sua conta por SMS.",
  consultYourAccountTextEmail: "Verifique sua conta por Email.",
  weSendASMS:
    "Enviaremos um SMS para o seu celular. Confirme o cadastro para acessar sua conta.",
  weSendASMSOrEmail:
    "Enviaremos um SMS ou Email. Confirme o cadastro para acessar sua conta.",
  welcomeToTheNewPlatform: "Bem-vindo à nova plataforma!",
  setNewPasswordByEmail: "Registre sua nova senha por Email.",
  setNewPasswordByClickingLinkEmail:
    "Registre sua nova senha clicando no link enviado para seu Email: ",
  weSendAEmail:
    "Enviaremos o código para o seu Email cadastrado. Confirme o cadastro para acessar sua conta.",
  certifyIamOfLegalAge:
    "Certifico que sou maior de 18 anos de idade e li e aceito os",
  generalTermsAndConditions: "Termos e Condições Gerais",
  and: "e",
  agent: "Agente",
  registrationCompleted: "Cadastro realizado!",
  important: "Importante!",
  accountVerificationBySMS:
    "Faça a verificação de sua conta clicando no link enviado por mensagem SMS.",
  accountVerificationByEmail:
    "Faça a verificação de sua conta clicando no link enviado por mensagem Email.",
  resendEmail: "Reenviar Email",
  close: "Fechar",
  hinitLogin: "O login é utilizado para entrar na sua conta.",
  loginAsACollaborator: "Entrar como colaborador ",
  registration: "Cadastro",
  trackYourBets: " Acompanhe suas Apostas",
  accessCredential: "CREDENCIAL DE ACESSO",
  UseYourPhoneToEnterOurWebsite:
    "Utilize seu número de telefone para entrar em nosso site.",
  createSecure8DigitPassword:
    "Crie uma senha segura de 8 digitos com Letras e Números.",
  hinitPassword:
    "Informe uma senha com 8 caracteres contendo letras e números.",
  save: "Salvar",
  wait: "Aguarde",
  requiredInput: "Campo Obrigatório *",
  repeatThePassword: "A confirmação deve ser igual à senha",
  all: "Todos",
  logingYourPhone: "Login (Seu Telefone)",
  validPhone: "Digite um Telefone válido",
  registrationBeenCompleted: "Parabéns, seu cadastro foi realizado!",
  successRegisterMsg:
    "Agora você é um membro do nosso site e pode acompanhar suas apostas acessando sua área através de seu login. Desde já, gostaríamos de agradecer sua confiança!",
  required: "Campo obrigatório",
  max: "Você atingiu o máximo de 50 caracteres",
  docMax: "Você atingiu o máximo de 50 caracteres",
  docCPF: "O documento CPF deve conter 14 caracteres",
  nameValid: "Digite Nome e Sobrenome",
  phoneCounter: "Digite um número válido (DDD + Número)",
  birthdate: "Proibido menores de 18 anos!",
  passMin: "Mínimo 8 caracteres contendo letras e números",
  passCaracter: "Obrigatório ter ao menos letras e números",
  validateCPF: "CPF Inválido",
  validEmail: "Digite um email válido.",
  usernameMax: "Digite no mínimo 5 caracteres",
  usernameAz09: "Digite um login válido",
  emailAlreadyRegistered: "E mail já cadastrado no sistema",
  loginAlreadyRegistered: "Login já cadastrado no sistema",
  forgotYourPassword: "Esqueceu sua senha?",
  managers: "Gestores",
  phoneLinkSMS: "Telefone (receba um link por SMS).",
  emailReciveLink: "Email (receba um link por email).",
  loginToStartProcess:
    "Por favor, forneça seu LOGIN abaixo para começar o processo de recuperar senha",
  doLogin: "Fazer Login",
  toRecover: "Recuperar",
  recoveryPassword: "Recuperar Senha",
  portuguese: "Português",
  spanish: "Espanhol",
  english: "Inglês",

  // JOBSON - TRADUCAO
  verificationAccount: "Verificação de Conta",
  verificationEmail: "Verificação de E-mail",
  informPassword: "Informe sua senha atual",
  // currentPassword: "Senha atual",
  oldPassword: "Informe uma nova senha",
  newPassword: "Nova senha",
  rulePassword: "Informe uma senha com 8 caracteres contendo letras e números",
  // confirmPassword: "Confirmar nova senha",
  // requiredInput: "Este campo é obrigatório",
  repeatPassword: "Repita a senha",
  changePassword: "Alterar senha",
  digitCodeBet: "Digite o código da aposta",
  next: "Avançar",
  cancelBet: "Cancelar aposta",
  // close: "Fechar",
  confirmCancelBet: "Confirmar cancelamento",
  code: "Código",
  digitPreBet: "Digite o código da pré-aposta",
  validatePreBet: "Validar pré-aposta",
  confirmPreBet: "Confirmar validação",
  pendent: "Pendente",
  lost: "Perdidas",
  awarded: "Premiadas",
  historic: "Histórico",
  sellCredit: "Vender crédito",
  search: "Pesquisar",
  notFoundBet: "Nenhuma aposta encontrada",
  yes: "Sim",
  no: "Não",
  currentBalance: "Saldo atual",
  limitSales: "Limite de vendas",
  remainingBalance: "Limite restante",
  weeekSales: "Vendas semanal",
  topClients: "Top clientes",
  // unlimited: "Ilimitado",
  sales: "Vendas",
  commission: "Comissão",
  prizesPaid: "Prêmios pagos",
  balance: "Balanço",
  user: "Usuário",
  period: "Período",
  date: "Data",
  qtdSales: "Qtd. vendas",
  accurate: "Apurado",
  cancel: "Cancelado",
  prizes: "Prêmios",
  validated: "Validada",
  notValidated: "Não validada",
  deal: "Acerto",
  balanceDay: "Saldo dia",
  balanceFinal: "Saldo final",
  grossValue: "Faturamento",
  salesCredit: "Vendas de crédito",
  resume: "Resumo",
  salesTotal: "Vendas total",
  totalCommission: "Comissão total",
  totalNet: "Líquido total",
  active: "Ativo",
  inactive: "Inativo",
  betCancel: " cancelada",
  betCode: "Aposta cod. ",
  betPlaced: " realizada",
  betPaid: " paga",
  betAttencion: "Atenção! Esta ação não poderá ser desfeita.",
  // cancel: "Cancelar",
  events: "Eventos",
  clients: "Clientes",
  // value: "Valor",
  return: "Retorno",
  result: "Resultado",
  // menuTable
  finalResult: "Resultado Final",
  overUnder: "Gols Acima/Abaixo",
  doubleChance: "Dupla Chance",
  GoalsEuropeanHandicap: "Gols (Handicap Europeu)",
  bothMark: "Ambas marcam",
  oneTwoBoth: "1X2 e Ambas",
  pointsUnderOver: "Pontos Acima/Abaixo",
  firstPeriodWinner: "Vencedor - 1º Set",
  // end menuTable
  paid: "Pago",
  action: "Ações",
  informNewPassword: "Informe uma nova senha abaixo",
  repeatNewPassword: "Repetir nova senha",
  goHomePage: "Ir para a Página Inicial",
  reset: "Redefinir",
  goToWebsite: "Ir para o site",
  goToSports: "Ir para Esportes",
  goToCasino: "Ir para Cassino",
  invitePlayer: "Convidar Jogador",
  exit: "Sair",
  // balance: "Saldo",
  // deposit: "Depositar",
  BALANCE: "SALDO",
  availableToCashout: "DISPONÍVEL PARA SAQUE",
  restrictBalance: "SALDO RESTRITO",
  balanceAgent: "SALDO AGENTE",
  BONUS: "BÔNUS",
  main: "Principais",
  specials: "Especiais",
  market: "Mercado",
  possibleReturn: "Retorno possível",
  allOdds: "Total odds",
  conference: "Conferência",
  BETCONFERENCE: "CONFERÊNCIA DE APOSTA",
  NOVALIDFORAWARD: "(SEM VALIDADE PARA RECEBIMENTO DE PRÊMIO)",
  tournament: "Torneio",
  reverseAmount: "Valor estornado",
  //Infotable
  pendentStatus: "Pendente",
  missed: "Errou",
  reimbursement: "Reembolso",
  right: "Acertou",
  // Pages
  carres: "Trabalhe conosco",
  contact: "Fale Conosco",
  appClient: "Download App Cliente",
  appAgent: "Download App Agente",
  help: "Regras",
  regulation: "Regulamento",
  terms: "Termos de Uso",
  suspend: "Desativar Sua Conta",
  responsibleGaming: "Jogo Responsável",
  privacy: "Política de Privacidade",
  bank: "Banco",
  bonus: "Bônus",
  profile: "Perfil",
  updateBalance: "Atualizar saldo",
  HowRecoverPassword: "Como você deseja recuperar sua senha ?",

  // MenuNavigationAgent
  homeAgent: "Início Agente",

  //
  // Tradução Daniel
  //
  // BTN's (Padrão)
  BtnCancel: "Cancelar",
  BtnSave: "Salvar",
  BtnNext: "Avançar",
  BtnDeposit: "Depositar",
  BtnWithdraw: "Sacar",

  // TAB's (Padrão)
  tabExtract: "Extrato",
  tabDeposit: "Depósito",
  tabWithdraw: "Saque",

  // =========================================
  // Dashboard USER view: profile.vue - Perfil
  // =========================================

  // TABS
  personalDataTitleTabInfo: "Info",
  personalDataTitleTabSecurity: "Segurança",

  // Dados Pessoais
  personalDataTitle: "Dados Pessoais",
  personalDataHint: "Encontre aqui suas informações pessoais.",
  personalDataFullName: "Nome Completo",
  personalDataDocument: "Documento CPF",
  personalDataBirthDate: "Data de Nascimento",

  // Dados de Contato
  contactDataTitle: "Dados de Contato",
  contactDataHint: "Encontre aqui suas informações de contato.",
  contactDataPhone: "Telefone",
  contactDataEmail: "Email",

  // Dados Financeiros
  financialDataTitle: "Dados Financeiros",
  financialDataHint: "Encontre aqui suas informações",

  // 'Tipo Chave PIX' e 'Chave PIX' ficam em aberto

  // Dados de Endereço
  addressDataTitle: "Dados de Endereço",
  addressDataHint: "Encontre aqui suas informações de endereço",
  addressDataPostal: "CEP",
  addressDataAddress: "Endereço",
  addressDataNumber: "Nº",
  addressDataDistrict: "Bairro",
  addressDataComplement: "Complemento",
  addressDataCityStateTitle: "Cidade - Estado",

  // Dados de Acesso
  credentialDataTitle: "Dados de Acesso",
  credentialDataHint: "Encontre aqui suas informações de acesso.",
  credentialDataLogin: "Login",
  credentialDataPassword: "Senha",
  credentialChangePassword: "Alterar Senha",

  // Autenticação de duas etapas
  twoStepsAuthTitle: "Verificação de duas etapas",
  twoStepsAuthHint:
    "Encontre aqui suas informações de Verificação de duas etapas.",
  twoStepsAuthAlertVerifyPhone:
    "Telefone verificado | Obs: Para ativar a verificação de duas etapas, é necessário verificar seu telefone.",
  twoStepsAuthBtnVerifyPhone: "Verificar meu telefone",

  // PERFIL - DIALOGS INFO / CREDENTIAL

  // DADOS PESSOAIS - dialogEditPersonal.vue
  profileDialogTitle: "Editar dados pessoais",
  profileDialogTreatmentTitle: "Título",
  profileDialogFullName: "Nome e Sobrenome",
  profileDialogDocument: "Documento (CPF)",
  profileDialogBirthDate: "Data de nascimento",
  // BTN's Cancelar e Salvar

  // DADOS DE CONTATO - dialogEditContact.vue
  profileDialogContactTitle: "Dados de Contato",
  profileDialogContactPhone: "Celular",
  profileDialogContactEmail: "Email",
  profileDialogContactEmailHint:
    "Para editar seu email, entre em contato conosco.",
  // BTN's Cancelar e Salvar

  // DADOS FINANCEIROS - dialogEditFinancial.vue
  profileDialogFinancialTitle: "Dados Financeiros",
  // Formas de pagamento para o exterior ainda estão indefinidas
  profileDialogFinancialPixKeyType: "Tipo de Chave Pix",
  profileDialogFinancialPhone: "Telefone",
  // BTN's Cancelar e Salvar

  // DADOS DE ENDEREÇO - dialogEditAddress.vue
  profileDialogAddressTitle: "Dados de Localização",
  profileDialogAddressPostal: "CEP",
  profileDialogAddressHomeAddress: "Endereço",
  profileDialogAddressNumber: "Nº",
  profileDialogAddressDistrict: "Bairro",
  profileDialogAddressComplement: "Complemento",
  profileDialogAddressEstado: "Estado",
  profileDialogAddressCity: "Cidade",
  // BTN's Cancelar e Salvar

  // ALTERAR SENHA
  // 1º Etapa
  profileDialogEditCredentialtitle: "Alterar Senha",
  profileDialogEditAlert: "Para continuar informe sua senha atual.",
  profileDialogEditPassword: "Senha",

  // 2º Etapa
  profileDialogEditChangePasswordAlert:
    "Defina uma senha segura usando letras e números.",
  profileDialogEditNewPassword: "Nova Senha",
  profileDialogEditNewPasswordHint:
    "Informe uma senha com 8 caracteres contendo letras e números.",
  profileDialogEditNewPasswordConfirm: "Confirmar senha",
  // BTN's Cancelar e Salvar

  // =========================================
  // Dashboard USER view: bonus.vue - Bônus
  // =========================================

  // INFOS BONUS
  displayBonusValue: "valor Bônus",
  displayeDeadline: "Data Limite",
  minimumQuotation: "Cotação Mínima",
  targetValue: "Valor Meta",
  qualifiedBets: "Apostas Qualificadas",
  bonusReleaseGoal: "Meta Liberação Bônus",

  // (TEXTO) Regra do Bônus
  bonusRuleP1: "Realize seu primeiro depósito e ative a oferta de Bônus.",
  bonusRuleP2Part1:
    " Após a consolidação do seu primeiro depósito, será concedido ",
  bonusRuleP2Part2:
    " bônus referente ao valor depositado. O limite de bônus e de $",
  bonusRuleP3:
    "Só será possível realizar apostas bônus com multiplicador mínimo de: ",
  bonusRuleP4:
    "Para conseguir autorizar o Bônus de Apostas será necessário realizar apostas qualificadas no valor total do Bônus Concedido do seu depósito, as apostas qualificadas devem ter cotação mínima de ",
  bonusRuleP5:
    "Exemplo: Bônus $20,00. Será necessário Apostar $20,00 em partidas com cotação igual ou superior à ",
  bonusRuleP6:
    "A sua aposta qualificada só será contabilizada para promoção bônus, quando as partidas forem finalizados.",
  bonusRuleP7:
    "Após cumprir a regra, e finalizadas as partidas, no dia seguinte o Bônus de Apostas serão creditado na sua conta como Valor de Bônus.",
  bonusRuleP8: "Os seus Bônus de Apostas não podem ser sacados.",
  bonusRuleP9:
    "O usuário não pode efetuar mais de uma aposta bônus na mesma combinação: evento e tipo aposta.",
  bonusRuleP10:
    "Os retornos resultantes de valores de aposta com Bônus de Aposta serão adicionados ao seu Saldo Disponível, mas valores de aposta em Bônus de Aposta não serão incluídos em quaisquer retornos.",
  bonusRuleP11:
    "Ex: Aposta Bônus de $10,00 com cotação de 3.00, Caso a aposta seja vencedora, serão adicionados $ .",
  bonusRuleP12: " a sua conta.",
  bonusRuleP13:
    "Para realizar um saque, é necessário ter realizado pelo menos um depósito.",
  autoBonusP9:
    "Para realizar um saque, é necessário ter realizado pelo menos um depósito.",

  // AUTOBONUS

  // REGRAS
  autoBonusTitle: "Regras",
  autoBonusP1: "Realize seu primeiro depósito e ative a oferta de Bônus.",
  autoBonusP2Part1:
    "Após a consolidação do seu primeiro depósito, será concedido  ",
  autoBonusP2Part2:
    " bônus referente ao valor depositado. O limite de bônus e de $",
  autoBonusP3:
    "Só será possível realizar apostas bônus com multiplicador mínimo de: ",
  autoBonusP4: "Os seus Bônus de Apostas não podem ser sacados.",
  autoBonusP5:
    "O usuário não pode efetuar mais de uma aposta bônus na mesma combinação: evento e tipo aposta.",
  autoBonusP6:
    "Os retornos resultantes de valores de aposta com Bônus de Aposta serão adicionados ao seu Saldo Disponível, mas valores de aposta em Bônus de Aposta não serão incluídos em quaisquer retornos.",
  autoBonusP7: "Ex: Ao depositar $10,00, automaticamente serão adicionados $ ",
  autoBonusP8: " a sua conta.",

  // ==========================================================
  // Dashboard USER view: dashboard/user/bank/index.vue - Banco
  // ==========================================================

  bankBalance: "Saldo",
  labelCurrency: "R$",
  awardRescue: "Resgate de Prêmio",
  bankHistoric: "Histórico",

  // Simple-table
  simpleTableDate: "Data",
  simpleTableId: "Cod.",
  simpleTableOperation: "Operação",
  simpleTableValue: "Valor",

  // ===========================================
  // Dashboard USER view: bankOnline.vue - Banco
  // ===========================================

  // As TABS Extrato - Depósitos - Saques (Padrão) estão no topo deste bloco de tradução

  // Extract Online Datatable
  // extractHeaders
  extractOnlineHeaderDate: "Data",
  extractOnlineHeaderOperation: "Operação",
  extractOnlineHeaderValue: "Valor",

  // Deposit Online Datatable
  // DepositHeaders
  depositOnlineHeaderId: "ID",
  depositOnlineHeaderValue: "Valor",
  depositOnlineHeaderStatus: "Status",
  depositOnlineHeaderDepositDate: "Data do Depósito",
  depositOnlineHeaderDepositQrcode: "QR Code",

  // Withdraw Online Datatable
  // WithdrawHeaders
  withdrawOnlineHeaderId: "ID",
  withdrawOnlineHeaderValue: "Valor Requisitado",
  withdrawOnlineHeaderStatus: "Status",
  withdrawOnlineHeaderKeyType: "Tipo de Chave",
  withdrawOnlineHeaderPixKey: "Chave Pix",
  withdrawOnlineHeaderDateRegister: "Data de Registro",

  // Select Label
  selectLabelTranslated: "Status do Depósito",

  // selectItems (Component)
  selectAll: "Todos",
  selectRequested: "Solicitado",
  selectConsolidated: "Consolidado",
  selectCanceled: "Cancelado",

  // ==========================================
  // Dashboard USER view: lis-bet-online.vue - Apostas (Dashboard online)
  // ==========================================

  // Bet Online
  // Headers
  listBetOnlineHeaderId: "ID",
  listBetOnlineHeaderDateHour: "Data/Hora",
  listBetOnlineHeaderEvents: "Eventos",
  listBetOnlineHeaderAmount: "Valor",
  listBetOnlineHeaderPrize: "Retorno",
  listBetOnlineHeaderResultBet: "Resultado",
  listBetOnlineHeaderPaid: "Pago",
  listBetOnlineHeaderAction: "Visualizar",

  // Select Label
  selectLabelBetOnlineTranslated: "Status Prêmio",
  // SelectItems
  selectAllbetOnline: "Todas",
  selectPaidsbetOnline: "Pagas",
  selectProcessingbetOnline: "Em processamento",

  // Search Label
  searchLabelBetonline: "Pesquisar",

  // v-chips
  chipIsLive: "ao vivo",
  chipIsBonus: "Bônus",

  // RESUMO DO PERÍODO
  // Resumo Título
  periodSummaryTitle: "Resumo do Período",
  periodSummaryValue: "Valor",
  periodSummaryPrizesPaid: "Prêmios Pagos",
  periodSummaryPossibleAwards: "Prêmios Possíveis",
  periodSummaryTotalPrizes: "Prêmios Totais",

  // ==========================================
  // Dashboard USER view: list-bet.vue - Apostas
  // ==========================================

  myBetsTitle: "Minhas Apostas",

  // bet_arr.length => apostas
  betArrLengthBets: "aposta(s).",
  betFromDate: "De",
  betToDate: "até",

  // list-bet search
  listBetLabelSearch: "Pesquisar",

  // Data Iterator - datainterator.vue
  // Alert Msg
  alertDataIteratorMyBets: "Nenhuma aposta encontrada com seus filtros.",

  // Footer
  MyItemsPerPage: "Itens por página:",
  currentPage: "página",
  ofPages: "de",

  // CardBetDataInterator - index.vue (Component)
  cardBetDataPreBetNumber: "Nº",
  cardBetDataPreBet: "Pré-aposta",
  cardBetDataPreBetEvents: "eventos",
  cardBetDataPreBetOdd: "odd",
  cardBetDataPreBetTotalOdds: "Total odds",
  cardBetDataPreBetValue: "Valor",
  cardBetDataPrePossibleReturn: "Retorno Possível",
  cardBetDataPreConference: "Conferência",

  // Agent
  enterTheHashCode: "Informe o código hash da aposta:",
  confirmPayment: "Confirmar Pagamento",
  payBet: "Pagar Aposta",
  hashCode: "Codigo Hash",
  validCode: "Digite um código válido",
  statusBetDoesntWin: "Status: aposta não ganha.",
  statusBetWonConfirmToPay: "Status: aposta ganha, confirme para pagar.",
  //Drawer Agent
  overview: "Visão geral",
  bets: "Apostas",
  // historic: "Histórico",
  // validatePreBet: "Validar pré-aposta",
  payPremium: "Pagar prêmio",
  // cancelBet: "Cancelar aposta",
  credit: "Crédito",
  // historic: "Histórico",
  financial: "Financeiro",
  extract: "Extrato",
  commissions: "Comissões",
  // bank: "Banco",
  account: "Conta",
  // changePassword: "Alterar Senha",

  // =======================================================
  // Dashboard AGENT view: registeredCustomers.vue - Apostas
  // =======================================================

  // Card "Digite o nome do Jogador"
  EnterPlayerNameTitle: "Buscar Jogador",
  // Card Placeholder
  EnterNameOrPhone: "Nome ou telefone",

  // Simple-Table
  sumPendent: "Pendente",
  sumLost: "Perdas",
  sumWin: "Ganhos",
  sumComission: "Comissão",
  sumBet: "Vendas",
  sumNetValue: "Valor Rede",

  extractByDay: "Extrato agrupado por dia:",
  previousBalance: "Saldo anterior",
  registeredCustomers: "Clientes Registrados",

  // itemsWeek
  lastSevenDaysLable: "Últimos 7 Dias",
  currentWeekLable: "Esta semana",
  lastWeekLable: "Semana passada",
  todayLable: "Hoje",
  yesterdayLable: "Ontem",

  // itemsHalfMonth
  lastFifteenDaysLable: "Últimos 15 dias",

  // itemsMonth
  currentMonthLable: "Mês atual",
  lasttMonthLable: "Mês passado",

  // DATEPICK prefix
  fromDateLable: "De:",
  toDateLable: "Até:",

  // DATEPICK locale
  localeDatepickLable: "pt-br",

  // DATEPICK Format
  datePickerStartLable: "DD/MM/YYYY",
  datePickerFinalLable: "DD/MM/YYYY",

  // Select Range
  intervalsLable: "Intervalos",
  schedule: "Horário",
  type: "Tipo",
  client: "Cliente",
  printTime: "Horário da Impressão",

  theBet: "Aposta",
  theBets: "Apostas",
  downloadPDF: "Baixar PDF",
  toPrint: "Imprimir",
  btnCopy: "Copiar",
  btnRefresh: "Atualizar",

  requested: "Solicitado",
  authorized: "Autorizado",
  consolidated: "Consolidado",
  canceled: "Cancelado",
  canceledCampaign: "Cancelada",
  tooltipCanceledCampaign:
    "Esta promoção foi cancelada pela plataforma. Os jogos inclusos não poderão mais ser jogados através desta promoção.",
  expired: "Expirado",
  expiredCampaign: "Expirada",
  profit: "Lucro",
  errorOnForm: "Existe erro(s) no formulário, revise suas informações.",

  // dialog-deposit.vue
  depositTitle: "Depósito PIX",
  depositLabel: "Valor ($)",
  depositPrefix: "R$",
  joinBonus: "BÔNUS NO DEPÓSITO DE",
  depositText: `Os depósitos são realizados via Pix. É obrigatório ter seu CPF cadastrado.`,
  btnPix: "Gerar Pix",
  btnDeposit: "Gerar Pix",
  paymentTitle: "Pagamento",
  paymentText:
    "Para realizar o pagamento via pix faça a leitura do QR Code no aplicativo do seu banco ou clique no botão para copiar o código.",
  depositValue: "Valor do depósito: R$",
  particleOr: "Ou",
  iconTitle: "Código Pix",

  // dialog-withdraw
  withdrawTitle: "Saque",
  withdrawText: "Após a solicitação o saque será enviado para análise.",
  withdrawTax: "Taxa sobre saque: ",
  btnSend: "Enviar",
  withdrawLabel: "Valor (R$)",
  withdrawPrefix: "$",

  maleTitle: "Sr.",
  femaleTitle: "Sra.",

  ThisFieldIsRequired: "Este campo é obrigatório!",
  // repeatPassword: "Repita a senha",
  passwordRecover: "Redefinir senha",

  somethingWrong:
    "Algo deu errado, se o erro persistir entre em contato com nosso suporte.",
  reviewInformation: "Existe erro(s) no formulário, revise suas informações.",

  // somethingWrong: "Algo deu errado, se o erro persistir entre em contato com nosso suporte.",
  // reviewInformation: "Existe erro(s) no formulário, revise suas informações.",
  brazil: "Brasil",
  southAmerica: "América do Sul",
  europe: "Europa",
  international: "Internacional",
  asia: "Asia",
  oceania: "Oceania",
  africa: "Africa",
  unitedStates: "Estados Unidos",
  europe2: "Europa 2",
  europe3: "Europa 3",
  southAmerica2: "South America 2",
  middleEast: "Oriente Médio",
  ufcBoxing: "UFC/Boxe",
  liberators: "Libertadores",

  reponsibleGaming: "Jogo Responsável",
  accountSuspend: "Suspensão da Conta",
  autoExclude: "Autoexclusão",
  confirm: "Confirmar",
  cantBeUndone: "Essa ação não pode ser desfeita.",
  suspendDescription:
    "Se desejar fazer uma pausa curta em sua atividade de apostas e de jogo por um curto período de tempo, poderá suspender sua conta até seis semanas. A suspensão da sua conta ainda permite que você realize saques, mas não depósitos ou apostas.",
  autoExcludeDescription:
    "Utilize a autoexclusão se considerar que está em risco de desenvolver um problema de jogo ou se acredita que atualmente possui um problema de jogo. A autoexclusão o impede de apostar conosco por um período específico entre 6 meses e 5 anos.",
  open: "Abrir",
  closed: "Fechada",
  monday: "Segunda",
  tuesday: "Terça",
  wednesday: "Quarta",
  thursday: "Quinta",
  friday: "Sexta",
  saturday: "Sábado",
  sunday: "Domingo",
  updateSystem: "Sistema Atualizado.",
  somethingDidntWork:
    "Algo não funcionou corretamente. Por favor, atualize sua página ou caso o problema persistir entre em contato com o nosso suporte.",
  copyNotification: "Copiado com sucesso!",
  textRadioConfirmRegister: "Desejo receber a confirmação de cadastro por:",
  textRadioRecoveryLogin: "Desejo receber a recuperação de login por:",
  viewBets: "Visualizar Apostas",
  gain: "ganho",
  betAmount: "Valor apostado",
  reversalAmount: "Valor estornado",
  newPlayer: "Adicionar novo jogador",
  rewardRedemption: "Resgate de prêmio",

  breaks: "Intervalos",
  invalidTime: "Invalid time",
  weeklyCalculation: "Apuração Semanal",
  currentCalculation: "Apuração Atual",
  from: "De",
  until: "Até",

  show: "Mostrar",
  sum: "Soma",
  nullData: "Nenhum dado encontrado no período selecionado.",
  formRegisterTitlePersonalData: "Dados Pessoais",
  formRegisterTitleAccessCredential: "Credencial de Acesso",

  indicatedBy: "Indicado por",
  recoverLoginMsg:
    "Digite seu CPF abaixo e enviaremos uma mensagem contendo seu login.",
  recoverLoginBtn: "Recuperar Login",

  interval: "Intervalo",
  filters: "Filtros",
  toClean: "Limpar",
  toFilter: "Filtrar",
  searchByName: "Pesquise por nome",
  searchPlayers: "Pesquisar Jogadores",
  paybet: "Pagar Aposta",
  periodSummaryPrizesToPaid: "Prêmios à pagar",
  simple: "Simples",
  double: "Dupla",
  triple: "Tripla",
  multiple: "Multipla",
  firstHalf: "1º Tempo",
  firstHalfExtension: "Prorrogação 1º Tempo",
  secondHalf: "2º Tempo",
  secondHalfExtension: "Prorrogação 2ª Tempo",
  sanctions: "Sanções",
  break: "Intervalo",
  totalTime: "Tempo Total",
  fullPeriodAfterOvertime: "Período integral após horas extras",
  fullPeriodAfterPenalties: "Período integral após pênaltis",
  matchNotStarted: "Partida não iniciada",
  firstQuarter: "1º Quarto",
  secondQuarter: "2º Quarto",
  thirdQuarter: "3º Quarto",
  fourthQuarter: "4º Quarto",
  overtime: "Hora extra",
  firstMap: "1º Mapa",
  secondMap: "2º Mapa",
  thirdMap: "3º Mapa",
  fourthMap: "4º Mapa",
  fifthMap: "5º Mapa",
  endOfMatch: "Fim de Partida",
  firstSet: "1º Set",
  secondSet: "2º Set",
  thirdSet: "3º Set",
  fourthSet: "4º Set",
  fifthSet: "5º Set",
  goldenSet: "Tie Break",
  firstInning: "1º Turno",
  secondInning: "2º Turno",
  thirdInning: "3º Turno",
  fourthInning: "4º Turno",
  fifthInning: "5º Turno",
  sixtyInning: "6º Turno",
  seventhInning: "7º Turno",
  eighthInning: "8º Turno",
  ninthInning: "9º Turno",
  extraInning: "Turnos Extras",
  firstRound: "1º Round",
  secondRound: "2º Round",
  thirdRound: "3º Round",
  fourthRound: "4º Round",
  fifthRound: "5º Round",
  sixtyRound: "6º Round",
  seventhRound: "7º Round",
  eighthRound: "8º Round",
  ninthRound: "9º Round",
  tenthRound: "10º Round",
  eleventhRound: "11º Round",
  twelfthRound: "12º Round",
  current_balance: "Saldo Remanescente",
  previous_balance: "Saldo Anterior",
  amlPolicy: "Política AML",
  betMinimum: "Aposta Mínima",
  betMaximum: "Aposta Máxima",
  activiteMinutes: "Mínutos de Atividade",
  minimumDeposit: "Mínimo Depósito",
  maximumDeposit: "Máximo Depósito",
  depositInterval: "Intervalo Depósito",
  depositLimitValue: "Valor Limite de Depósito",
  userLimitsSubtitle:
    "Encontre aqui os limites de Aposta, Depósito e Atividade",
  userLimits: "Limites Usuário",
  useTimeLimits: "Limites de Tempo de uso",
  depositLimits: "Limites de Depósito",
  bettingLimits: "Limites de Apostas",
  editLimits: "Editar Limites",
  depositLimitValues: "Valores Limite de depósito",
  depositTimeLimit: "Tempo Limite de depósito",
  twentyFourHours: "24 horas",
  fortyEightHours: "48 horas",
  sevenDays: "7 dias",
  thirtyDays: "30 dias",
  twentyMinutes: "30 Minutos",
  sixtyMinutes: "60 Minutos",
  ninetyMinutes: "90 Minutos",
  oneHundredTwentyMinutes: "120 Minutos",
  noLimits: "Sem Limites",
  noLimitBet: "Sem limite Aposta",
  noActivityLimit: "Sem limite Atividade",
  noDepositLimit: "Sem limite Depósito",
  noDepositTimeLimit: "Sem limite de Tempo de Depósito",
  youUsedTheSiteFor: "Você utilizou o site por",
  doYouWantToContinueBrowsing: "minutos. Deseja continuar navegando?",
  continue: "Continuar",
  timeOfUseController: "Controlador de Tempo de uso",
  messages: "Mensagens",
  description: "Descrição",
  noNewMessagesAtMoment: "Você não tem messagens novas no momento",
  message: "Mensagem",
  validatePromotion: "Validar Promoção",
  bonusAndPromotions: "Bônus e Promoções",
  promotionCode: "Codigo da Promoção",
  registerPromotionalCode: "Cadastrar código promocional",
  firstDepositBonus: "Bônus Primeiro depósito",
  promotionRules1:
    "Um cupom de promoção apenas pode ser resgatado uma única vez por usuário.",
  promotionRules2:
    "Os cupons promocionais podem ser encerrados a qualquer momento, eles tem data de ínicio e fim, e mesmo dentro do prazo de resgate, ele pode ter limitação na quantidade de pessoas que pode resgatá-lo. Não podendo mais ser mais utilizado.",
  sendThePromotionCodeHere: "Envie aqui o código da promoção:",
  rulesAndConditionsOfPromotions: " Regras e condições de promoções",
  validate: "Validar",
  invalid: "Inválida",
  addPunter: "Adicionar Apostador",
  namePlayer: "Nome Apostador",
  doYouWantToRemoveInvalidEvents: "Deseja remover os eventos inválidos?",
  accomplish: "Realizar",
  new: "NOVA",
  afterPerformingThe: "Após realizar a",
  betSendTheNewIDtoPunter:
    " aposta, envie o novo identificador (ID) para o Apostador",
  thereAreNoValidEventsForThisTicket:
    "Não existem eventos válidos para esse bilhete",
  placeNewBet: "Realizar NOVA aposta",
  checkInvalidBets: "Verifique as apostas inválidas",
  textBet: "Aposta",
  gameName: "Nome do Jogo",
  multiplier: "Multiplicador",
  cashOut: "Encerrar Aposta",
  noBetsFound: "Nenhuma aposta encontrada",
  pending: "Pendentes",
  resolved: "Resolvidas",
  closeBet: "Encerrar",
  dashboard: "Meu Painel",
  casino: "Cassino",
  videoSlots: "Slots em Vídeo",
  liveCasino: "Cassino ao Vivo",
  scratch: "Raspadinha",
  tableGames: "Jogos de Mesa",
  comingSoon: "Em breve",
  toPlayInTheCasinoRegistorOrLogin:
    "Para jogar no cassino, cadastre-se ou entre.",
  play: "Jogar",
  playNow: "Jogue agora",
  funPlay: "Jogar de Graça",
  onMaintenance: "Site em manutenção",
  onMaintenanceMessage:
    "Para melhor atendimento, estamos em manutenção. Por favor, tente novamente mais tarde.",
  roulette: "Roleta",
  unauthorizedLiveStream:
    "Você precisa estar logado para acessar o Live Stream.",
  unavailableTracker: "Rastreador indisponível para este evento",
  bettingTicket: "Bilhete de apostas",
  placeYourBet: "Faça sua aposta",
  shareCoupon: "Compartilhar meu Bilhete",
  expiredEvents: "Eventos Expirados",
  expiredEventsDetail: "Esses eventos expiraram: ",
  yesContinue: "Continuar mesmo assim",
  cleanCart: "Limpar Carrinho",
  viewInCasaDeApostas: "Ver na Casa das Apostas",
  pendingWithdraw: "Pendente",
  cancelWithdraw: "Cancelar Saque",
  cancelWithdrawExplanation:
    "Esse saque está pendente. Se solicitar o cancelamento, o valor solicitado irá ser adicionado ao seu saldo.",
  game: "Jogo",
  wallet: "Carteira Pay4Fun",
  myPromotions: "Minhas Promoções",
  promotions: "Promoções",
  promotionMaxBonus: "R$ {max_bonus} de Bônus",
  noPromotionForYou: "Não há promoções disponíveis no momento.",
  progressTooltip: "Você ainda precisa apostar R$ {betValueLeft}.",
  noActivePromotion: "Nenhuma promoção ativa no momento.",
  useCode: "Usar Código",
  rolloverProgressDescription:
    "Você pode acompanhar o progresso do seu bônus. Ao cumprir o rollover, poderá transferir seu saldo bônus para o seu saldo!",
  rolloverBetValue: "Valor Apostado",
  progress: "Progresso da Promoção",
  transferBalance: "Transferir Saldo",
  rolloverPercentageMissing: "Faltam {percentageMissing}%",
  rolloverCompleted: "Rollover Concluído",
  goBack: "Voltar",
  joinPromotion: "Aderir Promoção",
  knowMore: "Saber Mais",
  totalRollover: "Rollover Total",
  bonusGained: "Bônus Ganho",
  activePromotions: "Promoções Ativas",
  transformYourBonusIntoMoney: "Transforme seu bônus em dinheiro:",
  expiresIn: "Expira em",
  expiredIn: "Expirou em:",
  transfer: "Transferência",
  promoCode: "Código Promocional (Opcional)",
  promoCodeWithoutOptional: "Participe da Promoção",
  theDeposit: "o depósito",
  theAdmission: "a adesão",
  attention: "Atenção",
  when: "Quando",
  promotionIsConfirmedDeposit:
    "for confirmado, seu saldo de bônus será resetado e um novo processo de rollover será iniciado.",
  promotionIsConfirmedOther:
    "for confirmada, seu saldo de bônus será resetado e um novo processo de rollover será iniciado.",
  ifYouContinueAnd: "Caso continue e",
  currentlyYouGotThisPromotion:
    "Atualmente você tem a seguinte promoção ativa:",
  isConfirmedThisWillBeYourNewPromotionDeposit:
    "for confirmado, essa será sua nova promoção:",
  isConfirmedThisWillBeYourNewPromotionOther:
    "for confirmada, essa será sua nova promoção:",
  promotionalCodes: "Códigos Promocionais",
  promotionHistory: "Histórico de Promoções",
  noPromotionHistory: "Não há promoções anteriores.",
  finishedPromotion: "Finalizado",
  promotionDetail: "Detalhes da Promoção",
  seeDetail: "Ver Detalhes",
  nextBalance: "Saldo Posterior",
  operationName: "Nome da Operação",
  promotionUseDetail: "Detalhes Do Uso Da Promoção",
  actions: "Ações",
  seeRules: "Ver Regras",
  promotionRules: "Regras da Promoção",
  afterTransfer:
    "Após a transferência a promoção será finalizada, e caso haja saldo restante o valor será perdido.",
  afterTransferAnotherDialog:
    "Após a transferência a promoção será finalizada.",
  howItWorks: "Como Funciona",
  none: "Sem Promoção",
  firstDepositPromotion: "1º Depósito",
  depositPromotion: "Depósito",
  promotionBetsAfterTransfer:
    "Se alguma aposta relacionada a essa promoção ainda estiver pendente, ela não será mais válida.",
  gamingType: "Tipo de Jogo",
  totalAwards: "Total de Prêmios",
  totalComission: "Total de Comissões",
  casinoAndBetting: "Cassino e Apostas",
  sportsBetting: "Apostas Esportivas",
  noGamesFoundWhileSearching:
    "Nenhum jogo encontrado. Tente ajustar o termo da sua pesquisa.",
  noGamesFound: "No se han encontrado juegos.",
  doingLogin: "Fazendo Login",
  brazilCashFooter:
    "A Brasil Cash é uma forma rápida e segura de fazer seus depósitos via PIX. Após o pagamento, o saldo será creditado na hora!",
  brasilCashFooter2:
    "A Brasil Cash é uma empresa que atua na prestação de serviços de tecnologia própria como instituição de pagamento e subcredenciadora, inclusive, por meio de POS (máquina de cartão).",
  pixlancecertoFooter:
    "A LanceWallet é uma forma rápida e segura de fazer seus depósitos via PIX. Após o pagamento, o saldo será creditado na hora!",
  startingSoon: "Começa em {minutes} minutos",
  clientGains: "Cliente recebe",
  verification: {
    pageName: "Verificar",
    document: {
      name: "Identidade",
      description: `
        Por favor, faça o envio do seu documento de identidade e uma foto clara do
        seu rosto. Todos os documentos devem estar sobre uma superfície plana com
        os 4 cantos dentro da moldura. Todas as informações devem ser claras e
        identificáveis.
        `,
      acceptedDocuments: "Documentos aceitos para verificação:",
      alert:
        "Todos os dados são encriptados e armazenados com segurança. <br /> Uma vez editados, seus dados não poderão ser alterados.",
      possibleDocuments: {
        passport: "Passaporte",
        driversLicense: "Carteira de Motorista",
        identity: "Carteira de Identidade com CPF",
        workCard: "Carteira de Trabalho com CPF",
      },
      inputs: {
        documentFront: "Comprovante de Identidade (Frente)",
        documentVerse: "Comprovante de Identidade (Verso)",
        faceBiometry: "Foto de Rosto",
      },
      denied: {
        someMotives:
          "A reprovação da verificação de documentos pode ter sido por alguns fatores, como por exemplo:",
        motive1:
          "Documentos rasurados, amassados, ilegiveis, ou seja, fora dos padrões de aceitação.",
        motive2: "Documentos de terceiros.",
        motive3: "Fotos não compátiveis, embaçadas, sem iluminação adequada.",
        motive4: "Imagens com fundo repleto de informações.",
        doubts:
          "Você pode tentar entrar em contato com nosso suporte, se houver dúvidas. Sentimos muito, mas sua verificação foi recusada.",
      },
      alertMessage: {
        inProgress:
          "Seus documentos já foram enviados, aguarde enquanto processamos a validação.",
        finished:
          "Tudo certo! Você teve sua documentação verificada com sucesso.",
        denied:
          "Sua documentação não foi aprovada, alguns motivos podem ter influenciado.",
      },
      allowedTypes:
        "Os seguintes tipos de arquivo são aceitos: .png, .jpg, .pdf",
      sizeError: "A imagem tem mais que 900KB",
      minWidth: "A largura mínima pra a imagem do documento é de 1000px",
      sizeSumError:
        "A soma do tamanho das imagens não pode ser maior que 2.2MB.",
      faceBiometryMinWidth: "A largura mínima para a foto do rosto é 250px.",
      faceBiometryMinHeight: "A altura mínima para a foto do rosto é 250px.",
      documentNotVertical: "A imagem não pode estar vertical ou inclinada.",
      nothingSelected: "Nenhum arquivo selecionado",
      filesDetail:
        "As fotos dos comprovantes de identidade devem ser enviadas em formato paisagem (horizontal) e devem ter no mínimo 1000 pixels de largura. A foto de rosto deve ser clara, com resolução mínima de 250x250 pixels.",
      fileImgSame: "Envie um arquivo tipo IMAGEM igual ao documento da Frente",
    },
    bank: {
      name: "Banco",
      description: "Sua chave pix deve pertencer a um dos bancos autorizados:",
      alert: {
        success: "A verificação bancária foi concluída com sucesso.",
        inProgress:
          "A verificação bancária está em análise. Por favor, aguarde alguns instantes.",
      },
    },
    email: {
      name: "E-mail",
      btnResendVerify: "Reenviar e-mail de verificação",
      descriptionVerify: {
        text1:
          "Ao confirmar seu e-mail, você receberá promoções exclusivas de nossa plataforma!",
        text2:
          "Além disso, seu usuário será reconhecido no nosso sistema e nosso time de suporte ",
        text3: "estará sempre a disposição, caso necessário.",
      },
      tipVerify: {
        title: "Dicas:",
        tip1:
          "Quando solicitar reenvio de e-mail, sempre verifique o último e-mail enviado!",
        tip2:
          "Faça a verificação de sua conta clicando no link enviado por mensagem e-mail.",
        tip3: "Lembre-se de checar sua pasta de lixo eletrônico e/ou spam!",
        tip4:
          "Caso não tenha recebido, você pode solicitar outro após 1 minuto.",
      },
      successMessage: "Sua conta foi verificada! Boas apostas!",
    },
    phone: {
      name: "Telefone",
      btnVerify: "Enviar código",
      descriptionSecurityVerify: {
        text1:
          "Verifique seu número de telefone para garantir a segurança de sua conta.",
        text2:
          "Além disso, ao verificar, você pode ativar ou desativar a <strong>Verificação de duas etapas</strong>, em Perfil, Segurança.",
      },
      descriptionPhoneVerify: {
        title: "<strong>Como verifico meu telefone?</strong>",
        text1:
          "Clique em Enviar código, em seguida, você receberá um código via SMS no seu telefone cadastrado.",
        text2: "Insira o código nos campos e aguarde.",
        text3:
          "Caso você não receba o código ou o mesmo expire, solicite um novo.",
      },
      successMessage: "Seu telefone foi verificado com sucesso!",
    },
    status: {
      actionNeeded: "Ação Necessária",
      pendent: "Pendente",
      finished: "Concluído",
      inProgress: "Em Análise",
      denied: "Negado",
    },
  },
  finalWinner: "Vencedor Final",
  winner: "Vencedor",
  verificationAlertMessage:
    "Há uma ou mais verificações pendentes. Faça as verificações necessárias para realizar saques.",
  affiliatesPayments: {
    linkPlayer: "Vincular Jogador",
    transfers: "Transferências",
    invoiceEmission: "Emissão da Fatura",
    insertPlayerAccount:
      "Insira seu login e senha da sua conta de jogador que receberá os pagamentos.",
    linkedPlayer: "Jogador Vinculado",
    successLink: "Conta de jogador vinculada com sucesso.",
    infoLink:
      "Vincule uma conta de jogador. Nela você receberá o pagamento da sua comissão.",
    linkError:
      "Ocorreu um erro ao tentar encontrar informações da conta vinculada.",
    paymentReferringMonth: "Pagamentos referentes a",
  },
  casinoBetting: {
    setDateRange: "É preciso definir o intervalo de datas.",
    loadingBets: "Carregando apostas...",
    bet: "Aposta",
    bets: "Apostas",
    prize: "Prêmio",
    prizes: "Prêmios",
    betRefund: "Reembolso de Aposta",
    betsRefund: "Reembolsos de Apostas",
    prizeRefund: "Reembolso de Prêmio",
    prizesRefund: "Reembolsos de Prêmios",
    freespinPrize: "Prêmio de Freespins",
    profit: "Lucro",
    allGames: "todos os jogos",
    date: {
      last24Hours: "Últimas 24 horas",
      last48Hours: "Últimas 48 horas",
      last7Days: "Últimos 7 dias",
      dateInterval: "Intervalo de datas",
    },
    headers: {
      dateAndHour: "Data e hora",
      transactionId: "ID Transação",
      roundId: "ID Rodada",
    },
  },
  newCasino: {
    unloggedAtGame:
      "Para jogar <b>{game}</b> e muito mais, faça login ou crie sua conta.",
    showingGamesProgress: "Mostrando {current} de {total} jogos",
    loadMore: "Carregar Mais",
    pageTitle: {
      providers: "Provedores de Jogos de Cassino",
      provider: "{provider}",
      category: "{category}",
      game: "{game}",
    },
    providers: "Provedores",
    games: "Jogos",
    gamesFavorites: "Jogos favoritos",
    btnFavorite: "Favorito | Favoritar",
    relatedGames: "Jogos Relacionados",
    noProvidersFound: "Nenhum provedor encontrado.",
    noCategoriesFound: "Nenhuma categoria encontrada.",
    noGamesFoundLobby: "Nenhum jogo encontrado.",
    thisMasculine: "esse",
    thisFeminine: "essa",
    withFilters: " com esses filtros.",
    noGamesFound:
      "Não foram encontrados jogos para {thisPronoun} {model}{withFilters}",
    noGamesFoundFavorite: "Você ainda não adicionou jogos aos favoritos.",
    category: "categoria",
    categories: "Categorias",
    provider: "provedor",
    others: "outros",
    orderBy: "Ordenar por",
    volatility: {
      name: "Volatilidade",
      tooltip: `A volatilidade é fornecida pelos provedores de jogos. 
      Esta é utilizada para indicar aos jogadores a frequência 
      com que o slot atribui pagamento, e quão altos poderão 
      esperar que sejam os pagamentos.`,
      high: "Alta",
      "very-high": "Muito alta",
      "medium-high": "Média-alta",
      medium: "Média",
      "low-medium": "Média-baixa",
      low: "Baixa",
    },
    rtp: {
      tooltip: `RTP: O retorno ao jogador, ou RTP, em qualquer jogo, 
      é a percentagem esperada de valores de aposta que 
      um jogo específico retornará ao jogador ao longo de 
      um período de tempo.`,
    },
    search: {
      inputLabel: "O que você quer jogar?",
      recentSearches: "Pesquisas recentes",
      noRecentSearches: "Sem pesquisas recentes",
      searchFavoritesGames: "Procure aqui pelos seus jogos favoritos!",
      removeAllSearches: "Limpar tudo",
      gameNotFound: "Jogo não encontrado",
      verifySearchTerm:
        "Verifique se o nome está correto ou procure por outra palavra chave.",
      toPlayDo: "Para jogar, faça",
      createAnAccount: "crie uma conta",
    },
    freespins: {
      detail: "Detalhes",
      expiresIn: "Expira em {hour}h e {minute}m",
      gainFreeRounds: "Ganhe rodadas grátis!",
      claimDate: "Data de reinvidicação",
      rules: {
        titleDialogDepositCampaign: "Regras da Campanha",
        first:
          "1. A participação na campanha indica a aceitação integral dos termos e condições da mesma.",
        second:
          "2. O bônus é válido apenas para clientes cadastrados no site que reinvidicarem a campanha de freespin até a data de expiração.",
        third: "3. O bônus é válido apenas para os jogos contidos na campanha.",
        fourth:
          "4. Para usufruir desta promoção, após ativar a campanha, vá até o menu de Promoções Ativas e clique em Jogar.",
        fifth:
          "5. Esta promoção pode ter rollover de até 100x.",
        sixth: "6. Divirta-se com seus freespins!",
      },
      noCampaignFoundForGame:
        "Nenhuma campanha encontrada para o jogo pesquisado.",
      roundsClaimed: "Rodadas ganhas",
      roundsQuantity: "Qtd. de rodadas",
      noCampaignsAvailable:
        "Não foram encontradas campanhas de freespins disponíveis no momento.",
    },
  },
  firstPasswordRegistration: {
    rules: {
      description: "Sua senha deve atender esses requisitos:",
      oneUppercaseLetter: "É preciso ao menos uma letra maiúscula",
      oneLowercaseLetter: "É preciso ao menos uma letra minúscula",
      oneLowerAndUppercaseLetter:
        "É preciso ao menos uma letra maiúscula e uma minúscula",
      oneSpecialCharacter:
        "É preciso ao menos um caractere especial (#?!@$%^&*-)",
      oneNumber: "É preciso ao menos um número",
      eightCharacters: "A senha precisa ter exatamente 8 caracteres",
      confirmation: "A senha e a confirmação devem ser iguais",
      betweenEightAndTwelveCharacters:
        "A senha precisa ter entre 8 e 12 caracteres",
    },
  },
  fullscreen: "Tela Cheia",

  goToMyPromotions: "Ir para Minhas Promoções",
  newRegister: {
    registerToBet: "Faça seu cadastro para apostar!",
    welcome:
      "<strong>Boas vindas a nossa plataforma, {playerName}! &#127881;</strong>",
    infoLoginAndSupport:
      "Seu login será feito com o mesmo endereço de e-mail utilizado durante o cadastro. Caso tenha alguma dúvida, estaremos a disposição para ajudar.",
    makeYourDeposit: "Faça seu primeiro depósito e boas apostas! &#128526;",
    agreeAdulthood:
      "Ao registrar-se, você concorda que é maior de 18 anos de idade e aceita os ",
    andThe: " e a ",
    emailsDontMatch: "Emails não correspondem",
    emailLabel: "E-mail (insira um e-mail válido",
    emailLabelTooltip: "Esse email será utilizado como Login de sua conta.",
  },
  confirmEmail: "Verificar meu e-mail",
  verifyEmailBeforeWithdraw: "Para sacar, você precisa verificar o seu e-mail.",
  verifySmsToken: {
    phoneVerification: "Verifique seu telefone",
    twoStepsAuthentication: "Verificação de duas etapas",
    insertTokenHere:
      "Um código foi enviado para seu celular cadastrado. <br /> Insira-o aqui.",
    invalidToken: "Código inválido",
    resendToken: "Reenviar código",
    resendTokenTimer: "Reenviar código ({seconds} seg)",
    deactivateTwoStepsAuthentication:
      "Você pode desativar essa verificação nas configurações de Perfil > Segurança",
    recommendActivateTwoStepsAuthentication:
      "Clique aqui para ativar a verificação de duas etapas ao fazer login (recomendamos para garantir a segurança de sua conta)",
  },
  noDataText: "Não há dados",
  noResultsText: "Não há dados para essa pesquisa",
  changeContactInfo: {
    emailAction: "Confirmação de mudança de email",
    phoneAction: "Confirmação de mudança de telefone",
    loginChangeAfterEmailChange:
      "Ao modificar seu email, seu login será modificado para o novo email.",
  },
};
export default pt;
